module.exports = __webpack_public_path__ + "img/W7004-thumb.23b9dff4.jpg";